import styled, { css, keyframes } from 'styled-components'
import { Box, Button, Flex } from 'vvs-uikit'

/**
 *  | Rank | ID | Boost | Earned Exp |
 */
export const ResponsiveGrid = styled(Box)<{ type?: 'body' | 'loader' }>`
  display: grid;
  grid-gap: 1em;
  align-items: center;

  padding: 0 24px;

  grid-template-columns: 60px 3fr 2fr 1fr;

  ${({ type, theme }) =>
    type &&
    css`
      background: ${theme.colors.paleYellow};
      padding: ${type === 'body' ? '12px 15px 0 15px' : '0 24px 12px 24px'};

      ${type === 'body' &&
      `
        ${theme.mediaQueries.md} {
          padding: 12px 24px 0 24px;
        }
        cursor: pointer;
      `}
    `}
`
export const ResponsiveFooterGrid = styled(Box)`
  display: grid;
  grid-gap: 1em;
  align-items: center;

  grid-template-columns: 60px 3fr 2fr 1fr;

  padding: 0 15px 12px 15px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 0 24px 12px 24px;
  }
`
export const Break = styled.div<{ hide?: boolean }>`
  height: ${({ hide }) => (hide ? '0px' : '1px')};
  background-color: lightgray;
  width: 100%;

  grid-column: span 4;
`

export const ScrollableDiv = styled.div`
  overflow-y: auto;

  height: calc(100vh - 215.5px);

  padding-bottom: 70px;
`

export const ExpandAnimation = keyframes`
  0% {
    max-height: 68px;
  }
  100% {
    max-height: calc(100vh - 247.5px);
  }
`
export const CollapseAnimation = keyframes`
  0% {
    max-height: calc(100vh - 247.5px);
  }
  100% {
    max-height: 68px;
  }
`

export const FooterContainer = styled.div<{ expanded: boolean; empty?: boolean }>`
  width: 100%;
  position: absolute;
  bottom: 0;
  background: ${({ theme }) => theme.colors.darkNightBlue};

  ${({ empty, expanded }) =>
    empty
      ? css`
          max-height: 80;
        `
      : css`
          animation: ${expanded ? ExpandAnimation : CollapseAnimation} 0.3s linear forwards;
        `};
`
export const InnerScrollWrapper = styled.div`
  max-height: calc(100vh - 247.5px);
  overflow-y: auto;
`
export const ExpandButtonWrapper = styled(Flex)`
  width: 100%;
  justify-content: center;
  position: absolute;
`
export const ExpandButton = styled(Flex)`
  cursor: pointer;
  transform: translateY(-32px);
  justify-content: center;
  width: 150px;
  background-color: ${({ theme }) => theme.colors.darkNightBlue};
  padding: 8px 16px 8px 16px;
  border-radius: 16px 16px 0px 0px;
`

export const ToTopButton = styled(Button)`
  position: absolute;
  width: 40px;
  height: 40px;

  border-radius: 100px;
  padding: 0px;

  top: -80px;
  right: 30px;

  background-color: ${({ theme }) => theme.colors.darkNightBlue};
`
